import script from "./UserHomeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserHomeView.vue?vue&type=script&setup=true&lang=ts"

import "./UserHomeView.vue?vue&type=style&index=0&id=7259f17e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7259f17e"]])

export default __exports__